import { useCallback, useState } from "react";
import { useApi } from "../../api/hooks/useApi";
import { useAuth } from "contexts/AuthContext";
import { User } from "types";
import { getApiErrorMessage } from "../../utils/apiError";

interface CourseProgress {
  currentChapter: string;
  currentLesson: string;
  completedLessons: string[];
}

// interface User {
//   id: string;
//   name: string;
//   avatar?: string;
//   courseProgress: CourseProgress;
// }

export function useToggleLessonCompletion() {
  const { request } = useApi();
  const { setUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Alterna a conclusão de uma lesson do usuário:
   * - Se já estiver em completedLessons → remove
   * - Se não estiver → adiciona
   * @param user usuário logado
   * @param lessonId id da lesson (ex: "cap1-l3")
   * @returns User atualizado ou null em caso de erro
   */
  const toggleLessonCompletion = async (
    user: User,
    lessonId: string
  ): Promise<User | null> => {
    setLoading(true);
    setError(null);
    try {
      // Busca usuário atualizado
      const freshUser = await request<User>(`/users/${user.id}`);

      const { courseProgress } = freshUser;

      if (!courseProgress) {
        throw new Error("Progresso do curso não encontrado");
      }

      const hasCompleted = courseProgress.completedLessons.includes(lessonId);

      const updatedCompletedLessons = hasCompleted
        ? courseProgress.completedLessons.filter((id) => id !== lessonId)
        : [...courseProgress.completedLessons, lessonId];

      const updatedProgress: CourseProgress = {
        ...courseProgress,
        completedLessons: updatedCompletedLessons,
        currentLesson: lessonId, // atualiza última assistida
      };

      const updatedUser = {
        ...freshUser,
        courseProgress: updatedProgress,
      };

      // Atualiza no backend
      await request(`/users/${user.id}`, {
        method: "PATCH",
        body: JSON.stringify({
          courseProgress: updatedProgress,
        }),
      });

      localStorage.setItem('user', JSON.stringify(updatedUser));
      setUser(updatedUser);

      return updatedUser;
    } catch (err: any) {
      console.error("Erro ao alternar progresso:", err);
      setError(getApiErrorMessage(err, "Erro ao alternar progresso"));
      return null;
    } finally {
      setLoading(false);
    }
  };

  const isContentCompleted = useCallback(
    (user: User, lessonId: string) => {
      console.log("lessonId:", lessonId);
console.log("completedLessons:", user.courseProgress?.completedLessons);
      return user.courseProgress?.completedLessons.includes(lessonId) ?? false;
    },
    []
  );

  return {
    toggleLessonCompletion,
    isContentCompleted,
    loading,
    error,
  };
}
